import * as moment from 'moment';

import { Validators } from '@angular/forms';

import { ComponentTypesEnum, UnspecifiedKeysEnum } from '../../../app/shared/enums/common';
import { FilterControlInterface } from '../../../app/shared/interfaces';
import { AutocompleteControl, DatepickerControl, Helper, SelectControl } from '../../../app/shared/classes';

import { ReportTypesEnum } from '../../../app/entries/panel/enums';
import { SelectOptionInterface } from '../../../app/shared/components/select';

export const PanelReportsAccountsStorageId = 'PanelReportsAccountsComponent';
export const PanelReportsGroupsStorageId = 'PanelReportsGroupsComponent';

export const PanelReportsFilterReportTypeSelector = 'filterReportType';
export const PanelReportsFilterDateSelector = 'filterDate';
export const PanelReportsFilterDateFromSelector = 'filterDateFrom';
export const PanelReportsFilterDateToSelector = 'filterDateTo';
export const PanelReportsFilterGroupControlSelector = 'group';
export const PanelReportsFilterAccountsControlSelector = 'accounts';
export const AreGroupReportsSelector = 'areGroupReports';
export const PanelReportsFilterCurrencySelector = 'filterCurrency';

export const PanelReportsFilterControls = (areGroupReports: boolean): FilterControlInterface[] => {
    const controls = [
        {
            name: PanelReportsFilterReportTypeSelector,
            placeholder: 'Report',
            controls: [
                new SelectControl({
                    name: PanelReportsFilterReportTypeSelector,
                    value: null,
                    placeholder: 'Report',
                    validators: [Validators.required],
                    componentType: ComponentTypesEnum.Select,
                    options: []
                }),
            ],
            shown: true,
            sortIndex: 1
        },
        {
            name: PanelReportsFilterDateSelector,
            placeholder: 'Date',
            controls: [
                new DatepickerControl({
                    name: PanelReportsFilterDateFromSelector,
                    value: null,
                    placeholder: 'Date from',
                    maxDate: moment().format('YYYY-MM-DD'),
                    validators: [Validators.required],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 1
                }),
                new DatepickerControl({
                    name: PanelReportsFilterDateToSelector,
                    value: null,
                    placeholder: 'Date to',
                    maxDate: moment().format('YYYY-MM-DD'),
                    validators: [Validators.required],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 2
                }),
            ],
            shown: true,
            sortIndex: 2
        },
        {
            name: PanelReportsFilterGroupControlSelector,
            placeholder: 'Group',
            controls: [
                new AutocompleteControl({
                    name: PanelReportsFilterGroupControlSelector,
                    value: UnspecifiedKeysEnum.UnspecifiedGroupsKey,
                    placeholder: 'Group',
                    validators: [],
                    componentType: ComponentTypesEnum.Autocomplete,
                    options: [
                        {
                            label: 'All',
                            value: UnspecifiedKeysEnum.UnspecifiedGroupsKey
                        }
                    ]
                })
            ],
            shown: true,
            sortIndex: 3
        },
        {
            name: PanelReportsFilterAccountsControlSelector,
            placeholder: 'Account',
            controls: [
                new AutocompleteControl({
                    name: PanelReportsFilterAccountsControlSelector,
                    value: null,
                    placeholder: 'Account',
                    validators: [Validators.required],
                    componentType: ComponentTypesEnum.Autocomplete,
                    options: [],
                })
            ],
            shown: true,
            sortIndex: 4
        },
        {
            name: PanelReportsFilterCurrencySelector,
            placeholder: 'Currency',
            controls: [
                new SelectControl({
                    name: PanelReportsFilterCurrencySelector,
                    value: null,
                    placeholder: 'Currency',
                    validators: [Validators.required],
                    componentType: ComponentTypesEnum.Select,
                    options: []
                }),
            ],
            shown: true,
            sortIndex: 5
        },

    ];

    if (areGroupReports) {
        return controls.filter((control: FilterControlInterface) => control.name !== PanelReportsFilterAccountsControlSelector);
    }

    return controls;
};

export const AccountReportTypesOptions = (): SelectOptionInterface[] => {
    return [
        {
            label: Helper.textsHelper().getAccountReportName(ReportTypesEnum.Trades),
            value: ReportTypesEnum.Trades
        },
        {
            label: Helper.textsHelper().getAccountReportName(ReportTypesEnum.Adjustments),
            value: ReportTypesEnum.Adjustments
        },
        {
            label: Helper.textsHelper().getAccountReportName(ReportTypesEnum.OpenPositions),
            value: ReportTypesEnum.OpenPositions
        },
        {
            label: Helper.textsHelper().getAccountReportName(ReportTypesEnum.Detailed),
            value: ReportTypesEnum.Detailed
        },
        {
            label: Helper.textsHelper().getAccountReportName(ReportTypesEnum.TotalsBySymbol),
            value: ReportTypesEnum.TotalsBySymbol
        },
        {
            label: Helper.textsHelper().getAccountReportName(ReportTypesEnum.TotalsByDate),
            value: ReportTypesEnum.TotalsByDate
        },
        {
            label: Helper.textsHelper().getAccountReportName(ReportTypesEnum.SummaryByDate),
            value: ReportTypesEnum.SummaryByDate
        },
        {
            label: Helper.textsHelper().getAccountReportName(ReportTypesEnum.FeesByDestination),
            value: ReportTypesEnum.FeesByDestination
        }
    ];
};

export const GroupReportTypesOptions = (): SelectOptionInterface[] => {
    return [
        {
            label: Helper.textsHelper().getGroupReportName(ReportTypesEnum.GroupAdjustments),
            value: ReportTypesEnum.GroupAdjustments
        },
        {
            label: Helper.textsHelper().getGroupReportName(ReportTypesEnum.GroupOpenPositions),
            value: ReportTypesEnum.GroupOpenPositions
        },
        {
            label: Helper.textsHelper().getGroupReportName(ReportTypesEnum.GroupSummaryByDate),
            value: ReportTypesEnum.GroupSummaryByDate
        },
        {
            label: Helper.textsHelper().getGroupReportName(ReportTypesEnum.GroupTotalsBySymbol),
            value: ReportTypesEnum.GroupTotalsBySymbol
        },
        {
            label: Helper.textsHelper().getGroupReportName(ReportTypesEnum.TotalsByGroup),
            value: ReportTypesEnum.TotalsByGroup
        },
        {
            label: Helper.textsHelper().getGroupReportName(ReportTypesEnum.GroupFeesByDestination),
            value: ReportTypesEnum.GroupFeesByDestination
        },
        {
            label: Helper.textsHelper().getGroupReportName(ReportTypesEnum.TotalsByAccount),
            value: ReportTypesEnum.TotalsByAccount
        }
    ];
};
